
import React, { useState } from "react";
import { useEffect } from "react";
import RichTextEditor from "react-rte";

function TextItem({ item, setItem, editing, leftPadding, lang }) {
  const [editorState, setEditorState] = useState(RichTextEditor.createValueFromString(item.content[lang.code], "html"));
  const [text, setText] = useState(item.content[lang.code]);

  useEffect(() => {
    if (editing) setEditorState(RichTextEditor.createValueFromString(item.content[lang.code], "html"));
  }, [editing]);

  function handleEditorValueChange(value) {
    setEditorState(value);
    let temp = item.content || {};
    if (value.toString("html") === "<p><br></p>") {
      setText("");
      temp[lang.code] = "";
    } else {
      setText(value.toString("html"));
      temp[lang.code] = text;
    }
    setItem({ ...item, content: temp });
  }

  function linkAudioClip(source) {
    let temp = item;
    temp.audioClip[lang.code] = source;
    setItem({ ...temp });
  }

  // for displaying and saving text alignment in react-rte
  // https://github.com/sstur/react-rte/issues/402#issuecomment-855253098

  return (
    <>
      {editing ? (
        <>
          <div className="FW-content-properties" style={{ marginBottom: "0.25rem" }}>
            <div className="FW-attach-audio-clip">
              <label>
                <p>Audio clip: </p>
                <input type="text" value={item.audioClip[lang.code]} onChange={(e) => linkAudioClip(e.target.value)} />
              </label>
            </div>
          </div>
          <RichTextEditor value={editorState} onChange={handleEditorValueChange} />
        </>
      ) : (
        <>
          {item.content[lang.code]?.length > 1 ? (
            <div className="FW-content">
              <div
                className={`${leftPadding ? "left-padding" : ""}`}
                dangerouslySetInnerHTML={{ __html: item.content[lang.code] }}
              />
            </div>
          ) : (
            <div className="FW-content-missing-notification">[No text]</div>
          )}
        </>
      )}
    </>
  );
}

export default TextItem;
